const setState = {
    data: {
        ga4Accounts: [],
        ga4Properties: [],
        ga4DataStreams: [],
        gscSites: []
    },
    isEdited: {
        ga4AccountId: false,
        ga4PropertyId: false,
        ga4DataStreamId: false,
        gscSiteUrl: false,
        projectName: false
    },
    params: {
        ga4AccountId: '',
        ga4PropertyId: '',
        ga4DataStreamId: '',
        gscSiteUrl: '',
        projectName: '',
        tmpKey: ''
    },
    ga4: {
        params: {
            tmpKey: ''
        }
    }
};

const set = {
    namespaced: true,
    state: setState,
    mutations: {
        setEdited(state, payload) {
            Object.assign(state.isEdited, payload);
        },
        setData(state, payload) {
            Object.assign(state.data, payload);
        },
        setParams(state, payload) {
            Object.assign(state.params, payload);
        },
        setGA4Params(state, payload) {
            Object.assign(state.ga4.params, payload);
        },
        reset(state) {
            Object.assign(state.data, setState.data);
            Object.assign(state.isEdited, setState.isEdited);
            Object.assign(state.params, setState.params);
            Object.assign(state.ga4.params, setState.ga4.params);
        },
        resetGA(state) {
            state.data.ga4Accounts = [];
            state.data.ga4Properties = [];
            state.data.ga4DataStreams = [];
            state.isEdited.ga4AccountId = false;
            state.isEdited.ga4PropertyId = false;
            state.isEdited.ga4DataStreamId = false;
            state.params.ga4AccountId = '';
            state.params.ga4PropertyId = '';
            state.params.ga4DataStreamId = '';
        },
        resetGA4(state) {
            Object.assign(state.ga4.params, setState.ga4.params);
        },
        resetGSC(state) {
            state.data.gscSites = [];
            state.isEdited.gscSiteUrl = false;
            state.params.gscSiteUrl = '';
        }
    },
    actions: {
        setEdited({ commit }, response) {
            commit('setEdited', response);
        },
        setData({ commit }, response) {
            commit('setData', response);
        },
        setParams({ commit }, response) {
            commit('setParams', response);
        },
        setGA4Params({ commit }, response) {
            commit('setGA4Params', response);
        },
        reset({ commit }) {
            commit('reset');
        },
        resetGA({ commit }) {
            commit('resetGA');
        },
        resetGA4({ commit }) {
            commit('resetGA4');
        },
        resetGSC({ commit }) {
            commit('resetGSC');
        }
    }
};

export default set;
